<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <wbo-textarea-edit-control formControlName="description"
                                           [(ngModel)]="model.data.description"></wbo-textarea-edit-control>
            </fui-column>
            <fui-column>
                <wbo-text-edit-control formControlName="externalCode"
                                       [(ngModel)]="model.data.externalCode"></wbo-text-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
</fui-rows>
